import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _ from 'underscore';

@Component({
    selector: 'app-report-filters',
    templateUrl: './report-filters.component.html',
    styleUrls: ['./report-filters.component.scss'],
    standalone: false
})
export class ReportFiltersComponent implements OnInit {
  constructor() { }
  
  ngOnInit(): void {}
}
